import client from './client';
import { unwrapData } from './response';

export const AVAILABILITY_TODO = [
  'POST /availability/exceptions para vacaciones, feriados y excepciones por fecha'
];

export const getAvailability = async (params = {}) => {
  const response = await client.get('/availability', { params });
  return unwrapData(response);
};

export const listAvailabilityRules = async (params = {}) => {
  const response = await client.get('/availability/rules', { params });
  return unwrapData(response);
};

export const createAvailabilityRule = async (payload) => {
  const response = await client.post('/availability/rules', payload);
  return unwrapData(response, null);
};

export const updateAvailabilityRule = async (id, payload) => {
  const response = await client.patch(`/availability/rules/${id}`, payload);
  return unwrapData(response, null);
};

export const deleteAvailabilityRule = async (id) => {
  const response = await client.delete(`/availability/rules/${id}`);
  return unwrapData(response, null);
};
